import React from 'react'
import { Card, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'
import Shuffle from 'shufflejs'

export default class CommunityFeed extends React.Component {
  constructor (props) {
    super(props)
    this.props = props
    this.state = { items: 0 }
    this.row = React.createRef()
  }

  render () {
    if (!this.state?.items?.length) return
    return (
      <>
        <hr />
        <h1 className='mb-4'>Community Feed</h1>
        <Row className='row-cols-1 row-cols-md-2 row-cols-lg-4' ref={this.row}>
          {this.renderItems()}
        </Row>
      </>
    )
  }

  renderItems () {
    return this.state.items.map(item => {
      const url = `https://images.whitecliffsradio.co.uk${item.src}`
      return (
        <Col key={item.id} className='mb-3'>
          <Card>
            <Card.Body>
              <a href={url} data-lightbox='posters'>
                <OverlayTrigger placement='top' overlay={<Tooltip style={{ fontSize: '3em' }}>🔍</Tooltip>}>
                  <img src={url} style={{ width: '100%' }} />
                </OverlayTrigger>
              </a>
            </Card.Body>
          </Card>
        </Col>
      )
    })
  }

  async componentDidMount () {
    this.socket = window.io('/communityFeed')
    this.socket.on('update', items => this.setState({ items }))
  }

  componentDidUpdate () {
    if (!this.state.items === 0) return
    if (!this.shuffle) {
      this.shuffle = new Shuffle(this.row.current, {
        itemSelector: '.col'
      })
    }
    setTimeout(() => {
      this.shuffle.update()
    }, 300)
  }
}
